<template>
  <div class="foot w-1920">
    <div class="list w-1200">
      <router-link class="spen" tag="div" :to="{ name: 'Home' }">{{ $t('label.Home_Page') }}</router-link>
      <div class="img">
        <img src="../../assets/login/jiange.gif" alt="" />
      </div>
      <router-link class="spen" tag="div" :to="{ name: 'helpCenter1' }">{{ $t('label.Help_Center') }}</router-link>
      <div class="img">
        <img src="../../assets/login/jiange.gif" alt="" />
      </div>
      <router-link class="spen" tag="div" :to="{ name: 'helpCenter1', params: { id: 12 } }">{{ $t('label.Refund_Instructions') }}</router-link>
      <div class="img">
        <img src="../../assets/login/jiange.gif" alt="" />
      </div>
      <router-link class="spen" tag="div" :to="{ name: 'helpCenter1', params: { id: 17 } }">{{ $t('label.Legal_Statement') }}</router-link>

    </div>
    <div class="shengming w-1200">
      {{ $t('common.companyName') }} | {{ $t('foot.Copyright') }} 

       
  <!-- 网安备案 -->
  <span   v-if="$checkEnv('VUE_APP_NET_RECORD_NUM')"v-locales.zh>
    <a style="color: #7c7c7c; text-decoration: none" 
       href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37012602000129" 
       target="_blank">
    |  {{ $env('VUE_APP_NET_RECORD_NUM') }}|
    </a>
  </span>

  <!-- ICP备案 -->
  <span   v-if="$checkEnv('VUE_APP_RECORD_NUM')"v-locales.zh>
    <a style="color: #7c7c7c; text-decoration: none" 
       href="https://beian.miit.gov.cn" 
       target="_blank">
      {{ $env('VUE_APP_RECORD_NUM') }}
    </a>
  </span> </div>
  </div>
</template>
<script>
export default {
  methods: {
    ruzhu() {
      this.$message.warning({
        message: this.$t('message.Please_log_In_account')
      })
    }
  },
  handleMenuClick(id) {
    this.$router.tp({
      name: 'helpCenter',
      params: {
        id: id
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.foot {
  border-top: 3px solid #f5f5f5;
  width: 100%;

  .list {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    padding-right: 50px;

    .spen {
      color: #2c2a2b;
      font-size: 12px;
      margin-left: 10px;
      cursor: pointer;
    }

    .img {
      width: 2px;
      height: 14px;
      margin-left: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .shengming {
    height: 50px;
    line-height: 50px;
    color: #7c7c7c;
    font-size: 12px;
    text-align: center;
    padding-right: 43px;
  }

  .bottom {
    .lie {
      display: flex;
      justify-content: center;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-left: 25px;
        display: flex;
        align-items: center;

        img {
          width: 35px;
          height: 35px;
        }

        .spen {
          font-size: 12px;
          color: #98999b;
          width: 100px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
